import styled from "styled-components";

interface LocalesListProps {
  isVisible: boolean;
  direction?: string;
}

const LocalesList = styled.div<LocalesListProps>`
  position: absolute;
  right: ${({ direction }) => (direction === "rtl" ? "auto" : "4px")};
  left: ${({ direction }) => (direction === "ltr" ? "auto" : "4px")};
  top: 64px;
  background-color: white;
  border-radius: 12px;
  padding: 8px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  z-index: 20;
`;

export default LocalesList;
